import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const htmlTemplatesManagementReducer = foxGridReducer(
  gridNames.htmlTemplatesManagement,
);

export default htmlTemplatesManagementReducer;
